import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    maxWidth: "880px",
    margin: "32px auto",
    ...shorthands.padding(0, "16px"),
    display: "grid",
    rowGap: "16px",
    paddingTop: "40px",
    boxSizing: "border-box",
  },

  blockGap: { marginTop: "8px" },
  sectionGap: { marginTop: "16px" },

  card: {
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding("12px", "12px"),
    ...shorthands.borderLeft("4px", "solid", "#14243C"),
  },

  list: {
    marginTop: "4px",
    marginBottom: "4px",
    paddingLeft: "20px",
  },
  browserList: {
    listStyleType: "none",
    paddingLeft: 0,
    marginTop: "4px",
    marginBottom: "4px",
    "& li": {
      position: "relative",
      paddingLeft: "20px",
      marginBlock: "4px",
    },
    "& li::before": {
      content: '"→"',
      position: "absolute",
      left: 0,
      color: "#14243C",
      fontWeight: 700,
    },
  },

  muted: { color: tokens.colorNeutralForeground3 },
});
